export default "__VITE_ASSET__cb47d711__"